export const SAVE_PROPERTY_CONFIRMATION_STORAGE_KEY: string = 'saved-property-confirm-dialog-timestamp';
